<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-2" width="100%">
    <v-expansion-panel-header color="#708e92" class="white--text">
      <template v-slot:actions>
        <v-icon color="white"> $expand </v-icon>
      </template>
      Who should I contact before attempting to file a missing person report?
    </v-expansion-panel-header>
    <v-expansion-panel-content class="grey lighten-5">
      <v-row>
        <c-col id="faq-content">
          <v-card elevation="2" tile class="mt-8 mb-4">
            <v-card-text class="black--text">
              Prior to contacting the Reno Police Department, please contact the
              Washoe County Sheriff’s Office (jail), Washoe County Medical
              Examiner’s Office (morgue), and the local hospitals (medical
              centers and behavioral health centers) listed below. In some
              cases, your friend and/or family member may not be missing and may
              be located at one of these facilities.
              <ul class="my-2">
                <li>
                  Washoe County Sheriff’s Office (WCSO) – Booking:
                  <a href="tel:+17753282992">(775) 328-2992.</a>
                </li>
                <li>
                  Washoe County Medical Examiner’s Office:
                  <a href="tel:+17757856114">(775) 785-6114</a>
                </li>
                <li>
                  Renown Regional Medical Center (Reno):
                  <a href="tel:+1775">(775) 982-4100</a>
                </li>
                <li>
                  St. Mary’s Regional Medical Center (Reno):
                  <a href="tel:+17757703000">(775) 770-3000</a>
                </li>
                <li>
                  Northern Nevada Sierra Medical Center (South Reno):
                  <a href="tel:+17757997320">(775) 799-7320</a>
                </li>
                <li>
                  Northern Nevada Medical Center (Sparks):
                  <a href="tel:+1775331-7000">(775) 331-7000</a>
                </li>
                <li>
                  Northern Nevada Adult Medical Health Services (Sparks):
                  <a href="tel:+17756882001">(775) 688-2001</a>
                </li>
                <li>
                  Reno Behavioral Healthcare Hospital (Reno):
                  <a href="tel:+18777878518">(877) 787-8518</a>
                </li>
              </ul>
            </v-card-text>

            <v-card-text class="black--text py-0 mb-1"
              >If you are unable to locate the individual at any of the above
              locations, you may contact Non-Emergency Dispatch at
              <a href="tel:+17753342677">(775) 334-COPS (2677)</a> – Option 1,
              Option 3 to have an officer complete a report in person or over
              the phone.</v-card-text
            >
            <v-card-text class="black--text py-0 mb-1"
              >If you are unable to meet with an officer, you may report in
              person at the Main Station located at 455 E. 2 nd Street in Reno
              during business hours.</v-card-text
            >
            <v-card-text class="black--text pt-0 pb-4"
              >If you are out of state and a phone report cannot be completed by
              an officer, you may contact the Reno Police Department Front Desk
              during business hours at
              <a href="tel:+17753342175">(775) 334-2175.</a></v-card-text
            >
          </v-card>
        </c-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style scoped>
.bcs-expansion-content {
  color: black;
}
.howwrap {
  word-break: break-word;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "fd_faq_missing",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
